export default "__VITE_ASSET__DkhqglmD__"